export { default as Text } from "./Text";
export { default as Header } from "./Header";
export { default as CurrenecyText } from "./CurrenecyText";
export { default as DateText } from "./DateText";

